import { query } from '../utils/dom';
import EventEmitter from '../../utils/event-emitter';
import merge from '../../utils/merge';

/**
 * Base component class
 */
export default class Component extends EventEmitter {
  constructor (props) {
    super();
    this.props = merge(this.getDefaultProps(), props);
    // this.props = Object.assign(this.getDefaultProps(), props);
  }

  /**
   * Helper method to query DOM elements under the component
   *
   * @param {string} selector
   */
  $ (selector) {
    if (this.$element) {
      return query(selector, this.$element);
    }
  }

  /**
   * Returns the default properties for this component
   *
   * @return {Object}
   */
  getDefaultProps () {
    return {};
  }

  /**
   * Update the properties on this component
   *
   * @param {Object}  props
   * @param {boolean} update
   */
  setProps (props, update = true) {
    Object.assign(this.props, props);
    if (update) this.update();
  }

  /**
   * Checks if a component has been attached yet or not
   *
   * @return {Boolean}
   */
  isAttached () {
    return !!this.$element;
  }

  /**
   * Attach the component to the DOM
   *
   * @param {Element} element
   */
  attach (element) {
    this.detach();
    this.$element = element;
  }

  /**
   * Detach the component from the DOM
   */
  detach () {
    if (!this.$element) return false;
    this.$element = null;
  }

  /**
   * Re-render the component
   */
  update () {
    if (!this.$element) return false;
    this.$element.innerHTML = this.render();
  }

  /**
   * Render the component
   *
   * @return {String}
   */
  render () {
    return '';
  }

  /**
   * Destroy the component
   */
  destroy () {
    const $element = this.$element;
    this.detach();
    if ($element) {
      $element.remove();
    }
  }
}
